// src/utils/commonMethods.js

function getStockData(row) {
  if (!row) {
    console.error('Invalid row data');
    return null;
  }
  return row;
}

export function onPrice(responseData, row, router) {
  const stock = getStockData(row);
  if (!stock) return;
  let stockCode = stock[0];
  if (stockCode.startsWith('600') || stockCode.startsWith('601') ||
      stockCode.startsWith('603') || stockCode.startsWith('605') ||
      stockCode.startsWith('688')) {
    stockCode = stockCode+'.SH';
  } else if (stockCode.startsWith('000') || stockCode.startsWith('001') ||
            stockCode.startsWith('002') || stockCode.startsWith('300') ||
            stockCode.startsWith('301')) {
    stockCode =stockCode+'.SZ';
  } else if (stockCode.startsWith('43') || stockCode.startsWith('83') ||
            stockCode.startsWith('87') || stockCode.startsWith('88')) {
    stockCode = stockCode+'.BJ';
  }
  const searchQuery = `${stock[1]} ${stockCode}`;

  const url = router.resolve({ name: 'StockSearchFormPage', query: { searchQuery } }).href;
  window.open(url, '_blank');
}



export function onLine(responseData, row) {
  const stock = getStockData(row);
  if (!stock) return;

  const stockCode = stock[0]; // 假设 stock[0] 是股票代码
  let searchQuery = '';

  if (stockCode.startsWith('600') || stockCode.startsWith('601') ||
      stockCode.startsWith('603') || stockCode.startsWith('605') ||
      stockCode.startsWith('688')) {
    searchQuery = 'SH'+stockCode;
  } else if (stockCode.startsWith('000') || stockCode.startsWith('001') ||
            stockCode.startsWith('002') || stockCode.startsWith('300') ||
            stockCode.startsWith('301')) {
    searchQuery = 'SZ'+stockCode;
  } else if (stockCode.startsWith('43') || stockCode.startsWith('83') ||
            stockCode.startsWith('87') || stockCode.startsWith('88')) {
    searchQuery ='BJ'+ stockCode;
  } else {
    searchQuery = stockCode;
  }
  const externalUrl = `https://xueqiu.com/s/${encodeURIComponent(searchQuery)}`;
  window.open(externalUrl, '_blank');
}

export function onLHB(responseData, row, router) {
  const stock = getStockData(row);
  if (!stock) return;
  const stock_code = `${stock[0]}`;
  console.log(stock_code);
  const url = router.resolve({ name: 'StockDetailPage', query: { stock_code } }).href;
  window.open(url, '_blank');
}

export function onFHPS(responseData, row) {
  const stock = getStockData(row);
  if (!stock) return;

  const stockCode = stock[0]; // 假设 stock[0] 是股票代码
  let searchQuery = '';

  if (stockCode.startsWith('600') || stockCode.startsWith('601') ||
      stockCode.startsWith('603') || stockCode.startsWith('605') ||
      stockCode.startsWith('688')) {
    searchQuery = 'SH'+stockCode;
  } else if (stockCode.startsWith('000') || stockCode.startsWith('001') ||
            stockCode.startsWith('002') || stockCode.startsWith('300') ||
            stockCode.startsWith('301')) {
    searchQuery = 'SZ'+stockCode;
  } else if (stockCode.startsWith('43') || stockCode.startsWith('83') ||
            stockCode.startsWith('87') || stockCode.startsWith('88')) {
    searchQuery ='BJ'+ stockCode;
  } else {
    searchQuery = stockCode;
  }
  const externalUrl = `https://xueqiu.com/snowman/S/${encodeURIComponent(searchQuery)}/detail#/FHPS`;
  window.open(externalUrl, '_blank');
}




export function onWenCai(responseData, row) {
  const stock = getStockData(row);
  if (!stock) return;

  const searchQuery = stock[1];
  console.log(searchQuery);
  const externalUrl = `https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${encodeURIComponent(searchQuery)}`;
  window.open(externalUrl, '_blank');
}

export function onPrice1(responseData, row, router) {
  const stock = getStockData(row);
  if (!stock) return;

  const searchQuery = `${stock['股票简称']} ${stock['股票代码']}`;
  const url = router.resolve({ name: 'StockSearchFormPage', query: { searchQuery } }).href;
  window.open(url, '_blank');
}

export function onWenCai1(responseData, row) {
  const stock = getStockData(row);
  if (!stock) return;

  const searchQuery = stock['股票简称'];
  const externalUrl = `https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${encodeURIComponent(searchQuery)}`;
  window.open(externalUrl, '_blank');
}

export function onLine1(responseData, row) {
  const stock = getStockData(row);
  if (!stock) return;

  const [searchQuery, searchQuery1] = stock['股票代码'].split('.');
  const externalUrl = `https://xueqiu.com/s/${encodeURIComponent(searchQuery1 + searchQuery)}`;
  window.open(externalUrl, '_blank');
}





export function onLHB1(responseData, row, router) {
  const stock = getStockData(row);
  if (!stock) return;
  const [stock_code] = stock['股票代码'].split('.');
  const url = router.resolve({ name: 'StockDetailPage', query: { stock_code } }).href;
  window.open(url, '_blank');
}

export function formatDate(selectedDate) {
      const date = new Date(selectedDate);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
}

export function  getPreviousDate() {

      const date = new Date();
      date.setDate(date.getDate() - 1);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
}
